// @@JOBS_v86@@ shared bits for the Hiring pages.
export const APP_STATUSES = ['new', 'reviewing', 'interview', 'offer', 'hired', 'rejected'];
export const APP_LABELS = {
  new: 'New', reviewing: 'Reviewing', interview: 'Interview', offer: 'Offer', hired: 'Hired', rejected: 'Not a fit',
};
const TONES = {
  blue: ['rgba(110,168,255,.12)', '#6ea8ff', 'rgba(110,168,255,.22)'],
  purple: ['rgba(180,140,255,.12)', '#b48cff', 'rgba(180,140,255,.22)'],
  amber: ['rgba(232,193,90,.12)', '#e8c15a', 'rgba(232,193,90,.22)'],
  green: ['rgba(80,220,140,.12)', '#5fdc97', 'rgba(80,220,140,.22)'],
  grey: ['rgba(138,138,144,.12)', '#a1a1a8', 'rgba(138,138,144,.22)'],
};
const APP_TONE = { new: 'blue', reviewing: 'purple', interview: 'amber', offer: 'amber', hired: 'green', rejected: 'grey' };
const POSTING_TONE = { open: 'green', draft: 'amber', closed: 'grey' };

function pill(tone) {
  const [bg, fg, bd] = TONES[tone] || TONES.grey;
  return { display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: 11, fontWeight: 600, letterSpacing: '.04em', textTransform: 'uppercase', background: bg, color: fg, border: `1px solid ${bd}`, whiteSpace: 'nowrap' };
}
export const appPill = (s) => pill(APP_TONE[s]);
export const postingPill = (s) => pill(POSTING_TONE[s]);
export const LINK = { color: '#31b44b', textDecoration: 'none' };

export function fmt(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch { return '—'; }
}
